/**
 * Generated API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProductRevisionFilterType = {
    Previous: 'PREVIOUS',
    All: 'ALL'
} as const;
export type ProductRevisionFilterType = typeof ProductRevisionFilterType[keyof typeof ProductRevisionFilterType];

